<template>
  <div class="omni-app-page-title">
    <div class="page-title-wrapper">
      <div class="page-title-heading">
        <div v-if="icon.length > 0" class="page-title-icon">
            <template v-if="!iconIsLegacy">
                <FontAwesomeIcon :icon="icon" class="font-awesome" />
            </template>

            <template v-else>
                <i class="icon-gradient bg-midnight-bloom" :class="icon" />
            </template>
        </div>
        <div>
            <span v-html="title"/>
            <small class="d-block">
                <slot name="subTitle"/>
            </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OmniPageTitle",
  props: {
    title: { default: ''},
    icon: { default: ''},
  },
  computed: {
    /**
     * Determines if the icon prop contains a legacy icon, prefixed with 'pe-7s', or a new icon, prefixed with 'fa'.
     * This is used to determine which icon component to use: FontAwesomeIcon or the legacy icon system.
     */
    iconIsLegacy() {
        return this.icon.startsWith('pe-7s');
    },
  },
}
</script>

<style scoped>
.omni-app-page-title {
  margin: 0 0 1.5rem 0;
  position: relative;
}

.omni-app-page-title + .body-tabs-layout {
  margin-top: -30px !important;
}

.omni-app-page-title .page-title-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.omni-app-page-title .page-title-heading, .omni-app-page-title .page-title-subheading {
  margin: 0;
  padding: 0;
}

.omni-app-page-title .page-title-heading {
  font-size: 1.25rem;
  font-weight: 400;
  display: flex;
  align-content: center;
  align-items: center;
}

.omni-app-page-title .page-title-subheading {
  padding: 3px 0 0;
  font-size: 0.88rem;
  opacity: 0.6;
}

.omni-app-page-title .page-title-subheading .breadcrumb {
  padding: 0;
  margin: 3px 0 0;
  background: transparent;
}

.omni-app-page-title .page-title-actions {
  margin-left: auto;
}

.omni-app-page-title .page-title-actions .breadcrumb {
  margin: 0;
  padding: 0;
  background: transparent;
}

.omni-app-page-title .page-title-icon {
  font-size: 2rem;
  display: flex;
  align-items: center;
  align-content: center;
  text-align: center;
  padding: 0.83333rem;
  margin: 0 30px 0 0;
  background: #fff;
  box-shadow: 0 0.46875rem 2.1875rem rgba(4, 9, 20, 0.03), 0 0.9375rem 1.40625rem rgba(4, 9, 20, 0.03), 0 0.25rem 0.53125rem rgba(4, 9, 20, 0.05), 0 0.125rem 0.1875rem rgba(4, 9, 20, 0.03);
  border-radius: 0.25rem;
  width: 60px;
  height: 60px;
}

.omni-app-page-title .page-title-icon .font-awesome {
  color: rgb(75, 91, 116);
}

.omni-app-page-title .page-title-icon i {
  margin: auto;
}

.omni-app-page-title .page-title-icon.rounded-circle {
  margin: 0 20px 0 0;
}

.omni-app-page-title + .RRT__container {
  margin-top: -23.07692px;
}

.omni-app-page-title.omni-app-page-title-simple {
  margin: 0;
  background: none !important;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
}

.page-title-icon-rounded .page-title-icon {
  border-radius: 50px;
}
</style>
